import { makeStyles } from '@mui/styles';

const infoModelStyles = makeStyles({
    dialogContainer: {
        padding: '10px',
    },
    dialogWrapper: {
        display: 'flex',
        justifyContent: 'center',
        height: '100%',
        '& img': {
            maxWidth: '100%',
            width: 'auto',
            height: 'auto',
        },
    },
    close: {
        backgroundColor: (props) => props.colors.button.primaryBackground,
        color: (props) => props.colors.button.primaryForeground,
        padding: '10px',
        borderRadius: '5px',
        fontSize: '18px',
        textTransform: 'uppercase',
        cursor: 'pointer',
        border: '0px',
        '&:hover': {
            backgroundColor: (props) => props.colors.button.primaryBackground,
            color: (props) => props.colors.button.primaryForeground,
            filter: 'brightness(90%)',
        },
    },
    newsFlashContent: {
        '& a': {
            position: 'relative',
            display: 'inline-block',
            padding: '10px',
            color: (props) => props.colors.link_text_color,
            borderRadius: '5px',
            '& > button': {
                pointerEvents: 'none',
            },
            '&:visited': {
                color: (props) => props.colors.link_visited_color,
            },
            '&:hover': {
                color: (props) => props.colors.link_hover_color,
            },
        },
        '& img': {
            maxWidth: '100%',
        },
        '& button': {
            backgroundColor: (props) => props.colors.link_button_background_color,
            color: (props) => props.colors.link_button_text_color,
            border: '0px',
            padding: '10px 20px',
            borderRadius: '4px',
            fontSize: '14px',
            textTransform: 'uppercase',
            cursor: 'pointer',
            marginTop: '5px',
            '&:has(a)': {
                padding: '0',
            },
            '& > a': {
                padding: '10px 20px',
                color: 'inherit',
            },
            '&:disabled': {
                backgroundColor: (props) => props.colors.link_button_background_color,
                color: (props) => props.colors.link_button_text_color,
                filter: 'brightness(50%)',
            },
            '&:hover': {
                backgroundColor: (props) => props.colors.link_button_background_color,
                color: (props) => props.colors.link_button_text_color,
                filter: 'brightness(90%)',
            },
            position: 'relative',
        },
        '& .chaptersButton': {
            backgroundColor: (props) => `${props.colors.chapter_button.background_color} !important`,
            color: (props) => `${props.colors.chapter_button.text_color} !important`,
            '&:hover': {
                filter: 'brightness(90%)',
            },
            width: '100px',
            maxWidth: '100px',
            border: '1px solid #ffffff',
            cursor: 'pointer',
            padding: '10px',
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '14px',
            borderRadius: '4px',
            '& .chaptersButtonText': {
                overflow: 'hidden',
                margin: 0,
                WebkitBoxOrient: 'vertical',
                display: '-webkit-box',
                overflowWrap: 'break-word',
            },
            '&.chaptersActive': {
                backgroundColor: (props) => `${props.colors.chapter_button.active_color} !important`,
                color: (props) => `${props.colors.chapter_button.text_color} !important`,
                '&:hover': {
                    filter: 'brightness(90%)',
                },
            },
        },
        '& .activeChapterButton': {
            backgroundColor: (props) => `${props.colors.chapter_button.active_color} !important`,
            color: (props) => `${props.colors.chapter_button.text_color} !important`,
            '&:hover': {
                filter: 'brightness(90%)',
            },
        },
    },
});

export { infoModelStyles };
